import { Box, Image } from '@chakra-ui/react';

export const NotFoundImage = () => {
  return (
    <Box
      w="100%"
      bg="black"
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius={"40px"}
      py={8}
    >
      <Image
        src="media/images/404-image.jpg"
        alt="404 Page not Found"
        width={"100%"}
        h="auto"
      />
    </Box>
  );
};
